// extracted by mini-css-extract-plugin
export var headerXL = "RichText-module--headerXL--10VCc";
export var headerL = "RichText-module--headerL--2k8NS";
export var headerM = "RichText-module--headerM--2MSn8";
export var headerS = "RichText-module--headerS--vw8LH";
export var headerXS = "RichText-module--headerXS--JBgNj";
export var blogHeaderXL = "RichText-module--blogHeaderXL--16tnu";
export var blogHeaderL = "RichText-module--blogHeaderL--SHVxg";
export var blogHeaderM = "RichText-module--blogHeaderM--1D-Th";
export var blogHeaderS = "RichText-module--blogHeaderS--1XfLz";
export var blogHeaderXS = "RichText-module--blogHeaderXS--zddzb";
export var headerPreamble = "RichText-module--headerPreamble--2fmbX";
export var preHeader = "RichText-module--preHeader--3FkXn";
export var textNormal = "RichText-module--textNormal--2SI85";
export var textSmall = "RichText-module--textSmall--FLceL";
export var textSmallAlternate = "RichText-module--textSmallAlternate--1hTvd";
export var legend = "RichText-module--legend--3gG-N";
export var caption = "RichText-module--caption--1sjB4";
export var gradientBackground = "RichText-module--gradientBackground--1NWFQ";
export var ellipsis = "RichText-module--ellipsis--lPcrx";
export var globalContainer = "RichText-module--globalContainer--1Hk83";
export var maxWidth = "RichText-module--maxWidth--3ktC8";
export var clipBottom = "RichText-module--clipBottom--1MJux";
export var clipTopBottom = "RichText-module--clipTopBottom--2GAON";
export var post = "RichText-module--post--xZM0C";
export var ch2 = "RichText-module--ch2--k8b7o";
export var ch2Container = "RichText-module--ch2-container--NWKRK";